<template>
  <div class="warp_contrainer">
    <div class="search_container" style="text-align:right;">
      <el-button type="primary" @click="add()"
      ><i class="el-icon-plus"></i> 添加 </el-button>
    </div>
    <div class="table_container">
      <el-table :data="deliveryList" border style="width: 100%" stripe>
        <el-table-column
          prop="deliveryTitle"
          label="分拨点"
          align="center"
          width="200px"
        >
        </el-table-column>
        <el-table-column label="详细地址" align="left">
          <template slot-scope="scope">
            {{ scope.row.address }}
          </template>
        </el-table-column>
        <el-table-column label="负责人" align="center" width="200px">
          <template slot-scope="scope">
            {{ scope.row.contact }}
          </template>
        </el-table-column>
        <el-table-column label="联系方式" align="center" width="200px">
          <template slot-scope="scope">
            {{ scope.row.tel }}
          </template>
        </el-table-column>
        <el-table-column label="关联账户名" align="center" width="200px">
          <template slot-scope="scope">
            {{ scope.row.userName }}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="200px">
          <template slot-scope="scope">
            <el-button type="text" @click="edit(scope.row)">修改</el-button>
            <!-- <el-popconfirm
              confirmButtonText='确定'
              cancelButtonText='取消'
              icon="el-icon-info"
              iconColor="red"
              title="确定删除该数据？"
              @confirm="deleteData(scope.row.addressId)"
            > -->
            <template>
                <el-button type="text" @click="deleteData(scope.row.addressId)" style="color:red">删除</el-button>
              </template>
            <!-- </el-popconfirm> -->
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="pagination">
        <el-pagination
          :page-sizes="paginations.page_sizes"
          :page-size="paginations.page_size"
          :layout="paginations.layout"
          :total="paginations.total"
          :current-page="paginations.page_index"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        >
        </el-pagination>
      </div>
    </div>

    <el-dialog
      :visible.sync="editDialog.show"
      :title="editDialog.title"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      width="520px"
      center :show-close="false"
    >
      <el-form
        :model="editDialog.data"
        :rules="editDialog.form_rules"
        ref="editForm"
        label-position="right"
        label-width="120px"
      >
       <div class="first" v-if="editDialog.step==1||editDialog.step==3">
        <el-form-item prop="contact" label="负责人姓名：">
          <el-input
            v-model="editDialog.data.contact" type="text" placeholder="请输入负责人姓名" style="width: 300px"
          ></el-input>
        </el-form-item>
        <el-form-item prop="tel" label="负责人电话：">
          <el-input
            v-model.trim="editDialog.data.tel" type="text"
            placeholder="请输入负责人电话"
            style="width: 300px"
            maxlength="20"
          ></el-input>
        </el-form-item>
        <el-form-item prop="deliveryTitle" label="分拨点：">
          <el-input
            v-model.trim="editDialog.data.deliveryTitle"
            type="text"
            placeholder="请输入分拨地址"
            style="width: 300px"
            minlength="128"
          ></el-input>
        </el-form-item>
        <el-form-item prop="address" label="详细地址：">
          <el-input
            v-model.trim="editDialog.data.address"
            type="textarea" :rows="2"
            placeholder="请输入分拨点详细地址"
            style="width: 300px"
            minlength="300"
          ></el-input>
        </el-form-item>
        <el-form-item prop="contactPhoto" label="负责人照片：" style="margin-bottom:0;">
          <el-upload
            class="avatar-uploader"
            action=""
            :show-file-list="false"
            :http-request="handleLicenseImgFile"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload">
            <img v-if="editDialog.data.imageUrl" :src="process.env.IMG_URL+editDialog.data.imageUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
       </div>
       <div class="second" v-if="editDialog.step==3">
          <el-form-item prop="userName" label="用户名：">
          <el-input
            v-model="editDialog.data.userName" type="text" placeholder="请输入用户名" style="width: 300px"
           ></el-input>
          </el-form-item>
          <el-form-item prop="password" label="用户密码：">
            <el-input
              v-model.trim="editDialog.data.password" type="password"
              placeholder="请输入用户密码"
              style="width: 300px"
              maxlength="32"
            ></el-input>
          </el-form-item>  
       </div>
       <div class="second" v-if="editDialog.step==2">
          <el-form-item prop="userName" label="用户名：">
          <el-input
            v-model="editDialog.data.userName" type="text" placeholder="请输入用户名" style="width: 300px"
           ></el-input>
          </el-form-item>
          <el-form-item prop="password" label="用户密码：">
            <el-input
              v-model.trim="editDialog.data.password" type="text"
              placeholder="请输入用户密码"
              style="width: 300px"
              maxlength="32"
            ></el-input>
          </el-form-item>  
       </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialog.show = false" v-if="editDialog.step==1 || editDialog.data.addressId">取 消</el-button>
        <el-button type="primary" @click="editDialog.step=2" v-if="editDialog.step==1 && !editDialog.data.addressId">下一步</el-button>

         <el-button type="primary" @click="editDialog.step=1" v-if="editDialog.step==2 && !editDialog.data.addressId">上一步</el-button>
         <el-button type="primary" @click="submit()" v-if="editDialog.step==2 && !editDialog.data.addressId">提 交</el-button>
         <el-button type="primary" @click="submit()" v-if="editDialog.data.addressId">提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import * as mUtils from "utils/mUtils";
import * as deliveryApi from "@/api/delivery";
import * as img from "@/api/img";
import * as admin from "@/api/admin.js";
import { axios } from "utils/";
export default {
  data() {
    let dataValidate = (rule, value, callback) => {
      if (!value) {
        let text;
        if (rule.field == "contact") text = "请输入负责人姓名";
        else if (rule.field == "tel") text = "请输入负责人电话";
        else if (rule.field == "deliveryTitle") text = "请输入分拨点";
        else if (rule.field == "address") text = "请输入分拨点详细地址";
         else if (rule.field == "userName") text = "请输入用户名";
          else if (rule.field == "password") text = "请输入用户密码";
        return callback(new Error(text));
      } 
      return callback();
    };
    return {
      editDialog: {
        show: false,
        title: "修改",
        passwordBoolean:true,
        step:1,
        data: {
          addressId: null,
          deliveryTitle: "",
          address: "",
          contact: "",
          adminId:'',
          tel: "",
          contactPhoto:"",
          imageUrl:"",
          userName:"",
          password:""
        },
        form_rules: {
          contact: [
            {
              required: true,
              validator: dataValidate,
              trigger: "blur",
            },
          ],
          tel: [
            {
              required: true,
              validator: dataValidate,
              trigger: "blur",
            },
          ],
          deliveryTitle: [
            {
              required: true,
              validator: dataValidate,
              trigger: "blur",
            },
          ],
          address: [
            {
              required: true,
              validator: dataValidate,
              trigger: "blur",
            },
          ],
          userName: [
            {
              required: true,
              validator: dataValidate,
              trigger: "blur",
            },
          ],
          password: [
            {
              required: true,
              validator: dataValidate,
              trigger: "blur",
            },
          ]
        },
      },
      //需要给分页组件传的信息
      paginations: {
        page_index: 1, // 当前位于哪页
        total: 0, // 总数
        page_size: 20, // 1页显示多少条
        page_sizes: [5, 10, 20, 100], //每页显示多少条
        layout: "total, sizes, prev, pager, next, jumper", // 翻页属性
      },
      deliveryList: [], //列表
    };
  },
  created() {
    let that = this;
    that.getDeliveryList();
    that.rightCheck()
  },
  methods: {
    rightCheck(){
      let Id=mUtils.getStore('roleID')
      if(Id==2)
      this.$router.push('/distribution/order')
    },
    initData() {
      this.paginations.page_index = 1;
      this.getDeliveryList();
    },
    add(){
      this.editDialog.show = true;
      this.editDialog.step = 1;
      this.editDialog.title="添加";
      this.editDialog.data = {
        addressId: null,
        contact: "",
        tel: "",
        deliveryTitle: "",
        address: "",
        contactPhoto:"",
        imageUrl:"",
        userName:"",
        password:""
      };
    },
    edit(row) {
      this.editDialog.show = true;
      this.editDialog.step = 3;
      this.editDialog.title="修改";
      this.editDialog.data = {
        addressId: row.addressId,
        contact: row.contact,
        tel: row.tel,
        deliveryTitle: row.deliveryTitle,
        address: row.address,
        adminId:row.adminId,
        contactPhoto:row.contactPhoto,
        imageUrl:row.contactPhoto,
        userName:row.userName,
        password: row.password,
      }
    },
    submit() {
      let that = this;
      that.$refs.editForm.validate((valid) => {
        if (valid) {
          let data = {
            addressId: that.editDialog.data.addressId,
            contact: that.editDialog.data.contact,
            tel: that.editDialog.data.tel,
            deliveryTitle: that.editDialog.data.deliveryTitle,
            address:  that.editDialog.data.address,
            contactPhoto:that.editDialog.data.contactPhoto,
            userName:that.editDialog.data.userName,
            type:1,
            roleId:2,
            adminId:that.editDialog.data.adminId,
            password :that.$md5(that.editDialog.data.password)
            // that.$md5(that.editDialog.data.password)
          };
          // if (!data.addressId){
            
            
          // }
          const loading = this.$loading({
            lock: true,
            text: "loading",
            spinner: "el-icon-loading",
            background: "rgba(0,0,0,0.7)",
          });
          if (data.addressId){
            deliveryApi.deliveryUpdate(data).then(function (res) {
              loading.close();
              if (res.data.code != 0) {
                return that.$message.error(res.data.msg || "操作异常");
              }
              that.$message({message: "提交成功",type: "success"});
              that.getDeliveryList();
              that.editDialog.show = false;
            });
          }else{
            deliveryApi.deliveryAdd(data).then(function (res) {
              loading.close();
              if (res.data.code != 0) {
                return that.$message.error(res.data.msg || "操作异常");
              }
              that.$message({message: "提交成功",type: "success"});
              that.getDeliveryList();
              that.getA()
              that.editDialog.show = false;
            });
          }
        }
        
      });
    },
    /******/
    getA() {
      // 修改密码
      let data = {
        pageIndex: 1,
        pageSize: 1,
        userName: ''
      };
      var that=this
      admin.getAdminList(data).then(function (res) {
        if (res.data.code == 1202){
            return
        }
        if (res.data.code != 0) {
          return;
        } else {
       that.adminId=res.data.data.list[0].adminId
       that.changePassword()
        }
      });
     
    },
    changePassword(){
       let data = {
          adminId: this.adminId,
          password: this.$md5(this.editDialog.data.password),
          operatorId: mUtils.getStore("userinfo").adminId,
        };
        console.log(this.adminId);
        var that=this
        admin.updatePwd(data).then(function (res) {
          if (res.data.code != 0) {
            if (res.data.code == 1101) {
            } else if (res.data.code == 120) {

            } else {

            }
            return;
          } else {
            
          }
        });
    },
    getDeliveryList() {
      let that = this;
      let data = {};
      data.type=1;
      deliveryApi.deliveryList(data).then((res) => {
        if (res.data.code == 1202) {
          that.$router.push("/login");
          return;
        }
        if (res.data.code == 0) {
          that.deliveryList = res.data.data.list;

          that.paginations.total = res.data.data.pageCount;
        } else {
          that.$message.error("获取列表失败");
        }
      });
    },
    deleteData(addressId){
      let data = {
        addressId:addressId,
        status:-1
      };
      deliveryApi.deleteDeliverP(data).then((res) => {
        if (res.data.code == 1202) {
          this.$router.push("/login");
          return;
        }
        if (res.data.code == 0) {
          this.$message.success("删除分拨点成功");
          this.getDeliveryList()
        } else {
          this.$message.error("删除分拨点失败: "+res.data.msg);
        }
      });
    },
    // 每页多少条切换
    handleSizeChange(page_size) {
      let that = this;
      that.paginations.page_size = page_size;
      that.getDeliveryList();
    },
    // 上下分页
    handleCurrentChange(page) {
      let that = this;
      that.paginations.page_index = page;
      that.getDeliveryList();
    },
    handleLicenseImgFile: function (file) {
      let that = this;
      var formData = new FormData();
      formData.append("file", file.file);

      const loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      that.headers = {
        "Content-Type": "multipart/form-data",
      };
      img.upload(formData).then(function (res) {
        if (res.data.code == 0) {
          that.editDialog.data.contactPhoto = res.data.data.data.url;
          that.editDialog.data.imageUrl = res.data.data.data.path;
        }
      });
      loading.close();
    },
    handleAvatarSuccess(res, file) {
        //this.editDialog.data.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      let isJPG = "";
      if (file.type === "image/jpeg") {
        isJPG = file.type === "image/jpeg";
      } else if (file.type === "image/png") {
        isJPG = file.type === "image/png";
      } else if (file.type === "image/gif") {
        isJPG = file.type === "image/gif";
      }

      const isLt2M = file.size / 1024 / 1024 < 4;

      if (!isJPG) {
        this.$message.error("上传图片只能是.jpeg,jpg,gif,png格式文件!");
      }

      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 4MB!");
      }
      return isJPG && isLt2M;
    }
  },
};
</script>
<style scoped lang="less">
.warp_contrainer {
   .avatar-uploader {
    .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .el-upload:hover {
      border-color: #409EFF;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 178px;
      height: 178px;
      line-height: 178px;
      text-align: center;
    }
    .avatar {
      width: 178px;
      height: 178px;
      display: block;
    }
   }
}
</style>



// WEBPACK FOOTER //
// list.vue?a21c2942